import React from "react";
import {
  Col,
  Container,
  Row,
  Image,
  Button,
  Form,
  Card,
  Accordion,
} from "react-bootstrap";
import MIT from "../images/institutions/logo/MIT.png";
import machine from "../images/institutions/mit/machine.png";
import { BiTimeFive } from "react-icons/bi";
import {
  IoArrowDownCircle,
  IoSchoolSharp,
  IoSpeedometer,
} from "react-icons/io5";
import { BsTagFill } from "react-icons/bs";
import { FaFileVideo, FaLanguage, FaSchool, FaUserTie } from "react-icons/fa";
import { TiStarburst } from "react-icons/ti";
import {
  AiFillFacebook,
  AiFillLinkedin,
  AiFillTwitterCircle,
} from "react-icons/ai";
import "./Mit.css";
import one from "../images/institutions/mit/teachers/one.png";
import two from "../images/institutions/mit/teachers/two.png";
import three from "../images/institutions/mit/teachers/three.png";

export default function MitCourseOne() {
  return (
    <Container className="py-5">
      <div>
        <Row className="institution-head">
          <Col lg={8}>
            <h3>
              Machine Learning with Python: from Linear Models to Deep Learning
            </h3>
            <p>
              An in-depth introduction to the field of machine learning, from
              linear models to deep learning and reinforcement learning, through
              hands-on Python projects. -- Part of the MITx MicroMasters program
              in Statistics and Data Science.
            </p>
            <Image src={MIT} />
          </Col>
          <Col lg={4}>
            <Image src={machine} fluid />
          </Col>
        </Row>
        <Row>
          <Col>
            <h4>There is one session available</h4>
            <div className="institution-box">
              <p>Start date: Aug 2</p>
              <p2>End Date: Oct 10</p2>
            </div>
            <p>
              <span className="institution-enrolled">119,567</span> already
              enrolled!
            </p>
            <div>
              <Button className="insti-enroll-btn">Enroll Now</Button>
            </div>
            <div>
              <>
                <p className="insti-radio">
                  <Form.Check type="radio" aria-label="radio 1" />I would like
                  to receive email from MITx and learn about other offerings
                  related to Machine Learning with Python: from Linear Models to
                  Deep Learning.
                </p>
              </>
            </div>
          </Col>
        </Row>
      </div>
      <div className="insti-shadow">
        <Row className="insti-spacing">
          <Col lg={8}>
            <h1 className="insti-title">About this course</h1>
            <p className="insti-contact">
              If you have specific questions about this course, please contact
              us at <a href="react/route">sds-mm@mit.edu.</a>
            </p>
            <p>
              Machine learning methods are commonly used across engineering and
              sciences, from computer systems to physics...
            </p>
            <Accordion>
              <Card>
                <Card.Header>
                  <Accordion.Toggle as={Button} variant="link" eventKey="0">
                    <IoArrowDownCircle />
                    <span className="insti-padding">
                      More about this course
                    </span>
                  </Accordion.Toggle>
                </Card.Header>
                <Accordion.Collapse eventKey="0">
                  <Card.Body>
                    <p>
                      Moreover, commercial sites such as search engines,
                      recommender systems (e.g., Netflix, Amazon), advertisers,
                      and financial institutions employ machine learning
                      algorithms for content recommendation, predicting customer
                      behavior, compliance, or risk.
                    </p>
                    <p>
                      As a discipline, machine learning tries to design and
                      understand computer programs that learn from experience
                      for the purpose of prediction or control.
                    </p>
                    <p>
                      In this course, students will learn about principles and
                      algorithms for turning training data into effective
                      automated predictions. We will cover:
                    </p>
                    <ul>
                      <li>
                        Representation, over-fitting, regularization,
                        generalization, VC dimension;
                      </li>
                      <li>
                        Clustering, classification, recommender problems,
                        probabilistic modeling, reinforcement learning;
                      </li>
                      <li>
                        On-line algorithms, support vector machines, and neural
                        networks/deep learning.
                      </li>
                    </ul>
                    <p>
                      Students will implement and experiment with the algorithms
                      in several Python projects designed for different
                      practical applications.
                    </p>
                    <h4>
                      This course is part of theMITx MicroMasters Program in
                      Statistics and Data Science. Master the skills needed to
                      be an informed and effective practitioner of data science.
                      You will complete this course and three others from MITx,
                      at a similar pace and level of rigor as an on-campus
                      course at MIT, and then take a virtually-proctored exam to
                      earn your MicroMasters, an academic credential that will
                      demonstrate your proficiency in data science or accelerate
                      your path towards an MIT PhD or a Master's at other
                      universities. To learn more about this program, please
                      visit https://micromasters.mit.edu/ds/.
                    </h4>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </Accordion>
            <div>
              {" "}
              <h1 className="insti-title">What You'll Learn</h1>
              <ul>
                <li>
                  Understand principles behind machine learning problems such as
                  classification, regression, clustering, and reinforcement
                  learning
                </li>
                <li>
                  Implement and analyze models such as linear models, kernel
                  machines, neural networks, and graphical models
                </li>
                <li>Choose suitable models for different applications</li>
                <li>
                  Implement and organize machine learning projects, from
                  training, validation, parameter tuning, to feature
                  engineering.
                </li>
              </ul>
            </div>
            <div>
              <h1 className="insti-title">Syllabus</h1>
              <ul>
                <li>Introduction</li>
                <li>Linear classifiers, separability, perceptron algorithm</li>
                <li>Maximum margin hyperplane, loss, regularization</li>
                <li>
                  Stochastic gradient descent, over-fitting, generalization
                </li>
                <li>Linear regression</li>
                <li>Recommender problems, collaborative filtering</li>
                <li>Non-linear classification, kernels</li>
                <li>Learning features, Neural networks</li>
                <li>Deep learning, back propagation</li>
                <li>Recurrent neural networks</li>
                <li>Generalization, complexity, VC-dimension</li>
                <li>Unsupervised learning: clustering</li>
                <li>Generative models, mixtures</li>
                <li>Mixtures and the EM algorithm</li>
                <li>Learning to control: Reinforcement learning</li>
                <li>Reinforcement learning continued</li>
                <li>Applications: Natural Language Processing</li>
              </ul>
            </div>
            <div>
              <h1 className="insti-title">Projects</h1>
              <ul>
                <li>Automatic Review Analyzer</li>
                <li>Digit Recognition with Neural Networks</li>
                <li>Reinforcement Learning</li>
              </ul>
            </div>
          </Col>
          <Col lg={4}>
            <div>
              <div className="insti-right">
                <BiTimeFive /> Length: 15 Weeks
              </div>
              <div className="insti-right">
                <IoSpeedometer /> Effort: 10–14 hours per week
              </div>
              <div className="insti-right">
                <BsTagFill /> Price: FREE Add a Verified Certificate for ₹21,882
              </div>
              <div className="insti-right">
                <FaSchool /> Institution MITx
              </div>
              <div className="insti-right">
                <IoSchoolSharp /> Subject: Computer Science
              </div>
              <div className="insti-right">
                <TiStarburst /> Level: Advanced
              </div>
              <div className="insti-right">
                <FaLanguage /> Language: English
              </div>
              <div className="insti-right">
                <FaFileVideo /> Video Transcript: English
              </div>
              <div className="insti-right">
                <FaUserTie /> Course Type: Instructor-led on a course schedule
              </div>
            </div>
            <div className="insti-right">
              <h4>Associated Programs:</h4>
              <p>MicroMasters® Program Statistics and Data Science</p>
            </div>
            <div className="insti-right">
              <h4>Share This Course:</h4>
              <AiFillFacebook />
              <AiFillLinkedin />
              <AiFillTwitterCircle />
            </div>
            <div className="insti-right">
              <h4>Prerequisites:</h4>
              <ul>
                <li>6.00.1x or proficiency in Python programming</li>
                <li>6.431x or equivalent probability theory course</li>
                <li>College-level single and multi-variable calculus</li>
                <li>Vectors and matrices</li>
              </ul>
            </div>
            <div className="insti-right-box">
              <h4>Interested in this course for your Business or Team?</h4>
              <p>
                Train your employees in the most in-demand topics, with edX for
                Business.
              </p>
              <Button className="insti-right-btn">Purchase Now</Button>
            </div>
          </Col>
        </Row>
        <Row>
          <div>
            <h2 className="insti-title">Meet your instructors</h2>
            <Image src={MIT} />
            <h4>Massachusetts Institute of Technology </h4>
          </div>
          <Col lg={8}>
            <Row>
              <Col lg={6}>
                <Card style={{ width: "18rem" }}>
                  <Card.Img variant="top" src={one} />
                  <Card.Body>
                    <Card.Title> Regina Barzilay</Card.Title>
                    <Card.Text>
                      Delta Electronics Professor in the Department of
                      Electrical Engineering and Computer Science MIT
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
              <Col lg={6}>
                <Card style={{ width: "18rem" }}>
                  <Card.Img variant="top" src={three} />
                  <Card.Body>
                    <Card.Title> Tommi Jaakkola Thomas Siebel</Card.Title>
                    <Card.Text>
                      Professor of Electrical Engineering and Computer Science
                      and the Institute for Data, Systems, and Society MIT
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
              <Col lg={6}>
                <Card style={{ width: "18rem" }}>
                  <Card.Img variant="top" src={two} />
                  <Card.Body>
                    <Card.Title>Karene Chu </Card.Title>
                    <Card.Text>
                      Digital Learning Scientist and Research Scientist
                      Massachusetts Institute of Technology
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="insti-spacing">
          <Col lg={8}>
            <h3>
              Pursue a Verified Certificate to highlight the knowledge and
              skills you gain ₹21,882
            </h3>
            <div>
              <p>Official and Verified</p>
              <p>
                Receive an instructor-signed certificate with the institution's
                logo to verify your achievement and increase your job prospects
              </p>
            </div>
            <div>
              <p>Easily Shareable</p>
              <p>
                Add the certificate to your CV or resume, or post it directly on
                LinkedIn
              </p>
            </div>
            <div>
              <p>Proven Motivator</p>
              <p>
                Give yourself an additional incentive to complete the course
              </p>
            </div>
            <div>
              <p>Support our Mission</p>
              <p>
                edX, a non-profit, relies on verified certificates to help fund
                free education for everyone globally
              </p>
            </div>
          </Col>
        </Row>
        <Row className="insti-spacing">
          <Col lg={8}>
            <div>
              <h3>Frequently asked questions</h3>
              <p>
                Should you have further inquiries, go to micromasters.mit.edu/ds
                and use the "Contact us" button.
              </p>
            </div>
            <div>
              <h3>Who can take this course?</h3>
              <p>
                Unfortunately, learners from one or more of the following
                countries or regions will not be able to register for this
                course: Iran, Cuba and the Crimea region of Ukraine. While edX
                has sought licenses from the U.S. Office of Foreign Assets
                Control (OFAC) to offer our courses to learners in these
                countries and regions, the licenses we have received are not
                broad enough to allow us to offer this course in all locations.
                edX truly regrets that U.S. sanctions prevent us from offering
                all of our courses to everyone, no matter where they live.
              </p>
            </div>
          </Col>
        </Row>
      </div>
    </Container>
  );
}
